/**
 * AppleMailPrivacyCard component constants
 * @returns {Variables}
 */

export const DATE_PATTERN = 'MM/dd/yyyy';
